import styled from 'styled-components';
import 'react-dropdown/style.css';
import colors from '@theme/colors';

export const DropdownWrapper = styled.div`
  > label {
    color: ${colors.FORM_GREY};
    font-size: 12px;
    font-weight: 400;
  }
  .Dropdown-control {
    padding: 4px 1.5em 0 0;
    margin-top: 3px;
    border: none;
    border-bottom: 1px solid ${colors.BORDER_GREY};
    border-radius: 0;
    &:hover {
      box-shadow: none;
    }
    .Dropdown-placeholder {
      white-space: nowrap;
      color: ${colors.FORM_GREY};
      &.is-selected {
        color: #4a4a4a;
      }
    }
    .Dropdown-arrow {
      border-color: ${colors.BORDER_GREY} transparent transparent;
    }
  }
  .Dropdown-root.is-open .Dropdown-arrow {
    border-color: transparent transparent ${colors.PRIMARY};
  }
  .Dropdown-menu {
    top: calc(100% - 5px);
    font-size: 12px;
    color: ${colors.GREY};
    border-radius: 5px;
    .Dropdown-option {
      &.is-selected,
      &:hover {
        background-color: ${colors.LIGHT_GREY};
        color: ${colors.DARK_GREY};
        font-weight: 700;
      }
    }
  }

  .Dropdown-arrow {
    bottom: 8px;
    top: auto;
  }
`;



// WEBPACK FOOTER //
// ./components/atoms/Dropdown/layout.js